import React from "react";
import { Download, ExternalLink, FileText } from "lucide-react";

/** Admin-only brochure download / preview card. Lists the two A5 brochures
 *  (artist + business) with thumbnails, "Open" and "Download" actions. */
export default function BrochuresCard() {
  const brochures = [
    {
      slug: "artist",
      title: "For Artists, DJs & Podcasters",
      desc: "Your station. Your mic. Your money.",
      png: "/brochure-artist.png",
      view: "/brochure/artist",
    },
    {
      slug: "business",
      title: "For Local Businesses & Brands",
      desc: "Be heard everywhere. Be found online.",
      png: "/brochure-business.png",
      view: "/brochure/business",
    },
  ];

  return (
    <section className="mt-10" data-testid="brochures-card">
      <h2 className="fl-display text-2xl font-bold mb-4 flex items-center gap-2">
        <FileText className="w-5 h-5 text-emerald-500" /> Brochures (A5 · admin only)
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {brochures.map(b => (
          <div key={b.slug} className="fl-card p-4" data-testid={`brochure-card-${b.slug}`}>
            <a href={b.view} target="_blank" rel="noopener noreferrer" className="block group">
              <img
                src={b.png}
                alt={b.title}
                className="w-full rounded-lg border border-white/10 bg-black/40 transition-transform group-hover:scale-[1.01]"
                loading="lazy"
              />
            </a>
            <div className="mt-3 flex items-start justify-between gap-3">
              <div className="min-w-0">
                <div className="text-white font-bold">{b.title}</div>
                <div className="text-xs text-slate-400 truncate">{b.desc}</div>
              </div>
              <div className="flex gap-2 flex-shrink-0">
                <a
                  href={b.view}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="fl-btn ghost !py-1.5 text-xs"
                  data-testid={`brochure-view-${b.slug}`}
                >
                  <ExternalLink className="w-3.5 h-3.5" /> Open
                </a>
                <a
                  href={b.png}
                  download={`fliboe-brochure-${b.slug}.png`}
                  className="fl-btn !py-1.5 text-xs"
                  data-testid={`brochure-download-${b.slug}`}
                >
                  <Download className="w-3.5 h-3.5" /> PNG
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="text-xs text-slate-500 mt-3 fl-mono uppercase tracking-widest">
        // For printable PDF, open → File → Print → Save as PDF · A5 portrait
      </div>
    </section>
  );
}
